



























































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import GeneralDashboard from '@/components/lfs/NewStatistics/views/GeneralDashboard.vue'
import SurveyDashboard from "@/components/lfs/NewStatistics/views/SurveyDashboard.vue";
import SurveyDashboardDemo from "@/components/lfs/NewStatistics/views/SurveyDashboardDemo.vue";
import {Meta} from '@sophosoft/vue-meta-decorator';
import Tooltip from '@/components/UI/Tooltip.vue';
import StandmansDashboard from "@/components/lfs/NewStatistics/views/StandmansDashboard.vue";
import Scannings from "@/components/lfs/NewStatistics/views/Scannings.vue";
import IDownload from "@/components/icons/IDownload.vue";
import IClose from "@/components/icons/IClose.vue";
import Report from "@/components/lfs/NewStatistics/pdf/Report.vue";
import VueHtml2pdf from "vue-html2pdf";
import { interNormal, interMedium, interSemiBold, interBlack } from '@/helpers/fonts.ts'
import {dateTimeFormat} from "@/helpers/dateTimeFormat";
import {checkContour} from "@/helpers/checkContour";

const roistat = namespace('roistat')
const profile = namespace("profile")
const statistic_v4 = namespace('statistic_v4')
const event = namespace('event')

@Component({
  name: "PageStatistics",
  components: {
    Report,
    IClose,
    IDownload,
    Scannings,
    StandmansDashboard,
    Tooltip,
    GeneralDashboard,
    SurveyDashboard,
    SurveyDashboardDemo,
    VueHtml2pdf
  }
})
export default class PageStatistics extends Vue {
  @roistat.Action('sendEvent') protected sendEvent: any
  @profile.State("userCompany") protected userCompany: any
  @profile.Getter('plan') protected plan: any
  @statistic_v4.Action('loadPdf') protected loadPdf!: any
  @statistic_v4.Getter('loading') protected fetchLoading!: any
  @event.Getter('shows') protected shows:any

  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - ${this.$t('statistic.title')}`
    }
  }

  @Watch('$route', {immediate: true, deep: true})
  onParamsChange(newVal: any) {
    if (!newVal.query.tab) return
    this.tab = newVal.query.tab
  }

  @Watch('$i18n.locale')
  getLocale(NewVal: any) {
    // this.refresh()
  }

  errorsMes:boolean = false
  tab: string | null = null
  dialogPdf: boolean = false
  pdfLoading: boolean = false
  loading: boolean = true
  loadingSendEmail: boolean = false
  showEmailInput: boolean = false
  pdfDialogInput: string = ''
  isFormValid: boolean = false
  isEmailSend: boolean = false
  response:string|null = null

  clickBtn():void{
    this.dialogPdf = false
  }

  // focusOut(){
  //   if(!this.emailRulesValid){
  //     this.errorsMes = true
  //   } else {
  //     this.errorsMes = false
  //   }
  // }

  get isRequestsLoading() {
    return this.fetchLoading.total || this.fetchLoading.createdContacts || this.fetchLoading.contactAttributes || this.fetchLoading.standmansRating || this.fetchLoading.activeStandmans || this.fetchLoading.surveysFilled
  }

  get valid(){
    return this.pdfDialogInput.length >0 && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( this.pdfDialogInput)
  }

  emailRules: any[] = [
    (value: string) => !!value || this.$t('newstatistics.pdf.dialog.required'),
    (value: string) => (value && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) || this.$t('newstatistics.pdf.dialog.not_valid'),
  ]

  async beforeDownload({html2pdf, options, pdfContent}: any) {
    this.pdfLoading = true
    options.margin = [1, 0, 0.7, 0]
    const now = Date.now()
    await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf: any) => {
      const totalPages = pdf.internal.getNumberOfPages()

      const widthPercent = 0.082677
      const heightPercent = 0.116929

      pdf.addFileToVFS('Inter-Regular-normal.ttf', interNormal)
      pdf.addFont('Inter-Regular-normal.ttf', 'Inter-Regular', 'normal')
      // pdf.addFileToVFS('Inter-Medium-normal.ttf', interMedium)
      // pdf.addFont('Inter-Medium-normal.ttf', 'Inter-Medium', 'normal')
      pdf.addFileToVFS('Inter-SemiBold-normal.ttf', interSemiBold)
      pdf.addFont('Inter-SemiBold-normal.ttf', 'Inter-SemiBold', 'normal')
      pdf.addFileToVFS('Inter-Black-normal.ttf', interBlack)
      pdf.addFont('Inter-Black-normal.ttf', 'Inter-Black', 'normal')

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i)
        pdf.addImage(this.$refs.logo, 'PNG', (widthPercent * 3), (heightPercent * 1.7))
        pdf.setFont('Inter-Black')
        pdf.setFontSize(16)
        pdf.setTextColor('#4288C8')
        pdf.text('LEADFROG', (widthPercent * 10), (heightPercent * 3.05))
        pdf.text(this.shows[0].title, (widthPercent * 10), (heightPercent * 5))

        pdf.setDrawColor('#0785EC')
        pdf.setLineWidth(heightPercent / 4)
        pdf.line((widthPercent * 3), 11, (widthPercent * 97), 11)

        pdf.setFont('Inter-Regular')
        pdf.setFontSize(11)
        pdf.setTextColor('#0A0A0A')
        pdf.text(this.$t('newstatistics.pdf.page') + ' ' + i, this.getSpacing(widthPercent), (heightPercent * 96.5))
        pdf.text(this.$t('newstatistics.pdf.created') + ': ' + dateTimeFormat(now).rDate + ' ' + dateTimeFormat(now).rTime, (widthPercent * 3), (heightPercent * 96.5))
      }
      // const file = pdf.output('bloburl')
      // window.open(file, '_blank')
    })
      .save()
    this.pdfLoading = false
  }

  getSpacing(widthPercent: number) {
    if (this.$i18n.locale === 'ru') return widthPercent * 86.7
    else if (this.$i18n.locale === 'en') return widthPercent * 91.2
    else if (this.$i18n.locale === 'de') return widthPercent * 91
  }

  changeRouteMeta(value: string) {
    if (this.$route.query.tab == value) return
    this.$router.push({path: 'statistics', query: {tab: value}})
  }

  makePdfReport() {
    const html2pdf: any = this.$refs.html2Pdf
    html2pdf.generatePdf()
    this.dialogPdf = true
  }

  getReportName() {
    const date = dateTimeFormat(Date.now())
    return `Report-${date.rDate}-${date.rTime}`
  }

  closeDialog() {
    this.pdfDialogInput = ''
    this.showEmailInput = false
    this.dialogPdf = false
  }

  sendEventToRoistat(item: string) {
    let params = [
      {
        "name": "“Статистика”: Переход в " + (item == 'Анкеты' ? "“Анкеты”" :
          item == 'Стендисты' ? "“Стендисты”" :
            item == 'Сканирования' ? "“Сканирования”" : ""),
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  protected created() {
    this.response = checkContour('pdf', window.location.href)
    this.loadPdf()
  }

}
